import { TeamUserData } from "@Modules/teams/Data/Models/TeamUser";

export interface TeamUser extends TeamUserData {
  isOwner: () => boolean;
}

export default function TeamUserModel(user: TeamUserData): TeamUser {
  function isOwner(): boolean {
    return user.role?.toLowerCase() === "admin";
  }

  return {
    ...user,
    isOwner,
  };
}
